export const getMonitoringBaseUrl = ({ companyIdEncrypted, cryptoJS }) => {
    try {
        const proxyIds = JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS || "[]")
        const decryptedCompanyId = cryptoJS.AES.decrypt(companyIdEncrypted, process.env.VUE_APP_ENCRYPTION_PW).toString(cryptoJS.enc.Utf8)
        const useMonitoringApi = proxyIds.indexOf(decryptedCompanyId) === -1
        return useMonitoringApi ? process.env.VUE_APP_MONITORING_API_URL : process.env.VUE_APP_APIURL + "/monitoring-api"
    } catch (e) {
        return process.env.VUE_APP_MONITORING_API_URL
    }
}

export const getAddedPlatforms = ({ currentPlatforms = [], selectedPlatforms = [], caseInsensitive = true }) => {
    const normalize = (value) => {
        const str = String(value)
        return caseInsensitive ? str.toLowerCase() : str
    }
    const currentSet = new Set((currentPlatforms || []).map((p) => normalize(p)))
    return (selectedPlatforms || []).filter((p) => !currentSet.has(normalize(p)))
}

export const saveAiProjectSettings = async ({
    companyIdEncrypted,
    projectId,
    title,
    brandName,
    brandDomain,
    currentPlatforms,
    selectedPlatforms,
    axiosPost,
    cryptoJS,
    includePlatformsInUpdate = false,
    caseInsensitive = true
}) => {
    const addedPlatforms = getAddedPlatforms({ currentPlatforms, selectedPlatforms, caseInsensitive })

    const payload = {
        company_id: companyIdEncrypted,
        project_id: projectId,
        update: {
            title,
            brand: { brand_name: brandName, brand_domain: brandDomain }
        }
    }
    if (includePlatformsInUpdate && addedPlatforms.length) {
        payload.update.platforms = addedPlatforms
    }

    const baseUrl = getMonitoringBaseUrl({ companyIdEncrypted, cryptoJS })
    const url = baseUrl + "/ai-suite/project/update/information"
    await axiosPost(url, payload)

    return { addedPlatforms, baseUrl, payload }
}
